<div class="content">
  <div class="content__header">
    <span class="content__header__title">{{ title }}</span>
    <span>{{ subtitle }}</span>
  </div>
  <div class="content__body">
    <ng-content></ng-content>
  </div>
</div>
